import { Alert, Button } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { IS_LOADING } from "lib/graphql/return-is-loading-on-each-request"
import { withInitialValue } from "lib/graphql/with-initial-value"
import { getDraftComponentCount } from "../../controller/maintenance-library"
import { canReviewComponents } from "../lib/can-review-components"
import { VIEW_DRAFTS } from "../lib/library-views"

export function DraftReviewBanner() {
    const { onSelectView } = useBoundContext()
    const count = getDraftComponentCount.useResults(withInitialValue(IS_LOADING))

    if (!canReviewComponents()) return null
    if (count === IS_LOADING || !count) return null
    const message = `${count} ${"component".pluralize(count)} awaiting review.`
    return (
        <Alert
            severity="info"
            sx={{ mb: 3 }}
            data-cy="draft-review-banner"
            action={
                <Button color="inherit" size="small" onClick={showDrafts} data-cy="draft-review-banner-review-button">
                    Review Drafts
                </Button>
            }
        >
            {message}
        </Alert>
    )

    function showDrafts() {
        onSelectView(VIEW_DRAFTS)
    }
}
